import PropTypes from 'prop-types';
import { useState } from 'react';

import Modal from 'components/ui-kit/modal';
import Button from 'components/ui-kit/buttons/button';
import Typography from 'components/ui-kit/typography';
import { useModal } from 'hooks';
import { createEmptyTipData, DEFAULT_PRESET_PERCENTAGES } from 'helpers/payment-display.helper';

import TipSelector from 'components/invoices/invoice-payment-options-modal/components/tip-selector';

import * as S from './styles';

const InvoiceTipModal = ({
  totalAmount,
  tipBaseAmount,
  creditApplied,
  onContinue,
  presetPercentages,
}) => {
  const [tipData, setTipData] = useState(createEmptyTipData());
  const [isTipValid, setIsTipValid] = useState(true);
  const { hideModal } = useModal();

  const handleSkip = () => {
    onContinue(createEmptyTipData());
    hideModal();
  };

  const handleContinue = () => {
    onContinue(tipData);
    hideModal();
  };

  return (
    <Modal title="Add tip (optional)" isClosable={false}>
      <S.Box>
        <Typography fontSize={12} color="grey" fontFamily="regular">
          Tip is on full amount before taxes.
        </Typography>

        <TipSelector
          totalAmount={totalAmount}
          tipBaseAmount={tipBaseAmount}
          creditApplied={creditApplied}
          onTipChange={setTipData}
          onTipValidationChange={setIsTipValid}
          presetPercentages={presetPercentages}
          showHeader={false}
        />

        <S.ButtonGroup>
          <Button onClick={handleSkip} stretched>
            Skip
          </Button>
          <Button color="primary" onClick={handleContinue} stretched disabled={!isTipValid}>
            Continue
          </Button>
        </S.ButtonGroup>
      </S.Box>
    </Modal>
  );
};

InvoiceTipModal.propTypes = {
  totalAmount: PropTypes.number.isRequired,
  tipBaseAmount: PropTypes.number,
  creditApplied: PropTypes.number,
  onContinue: PropTypes.func.isRequired,
  presetPercentages: PropTypes.arrayOf(PropTypes.number),
};

InvoiceTipModal.defaultProps = {
  tipBaseAmount: null,
  creditApplied: 0,
  presetPercentages: DEFAULT_PRESET_PERCENTAGES,
};

export default InvoiceTipModal;
